var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#242424;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3475.527 1434.172)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3481.388 -1430.896)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3537.62-1367.451a3.067,3.067,0,0,1-.382-.081,1.023,1.023,0,0,1-.706-1.151,7.628,7.628,0,0,1,.293-1.267c.1-.384.225-.764.306-1.154a1.427,1.427,0,0,0,.026-.559.331.331,0,0,0-.274-.285,1.225,1.225,0,0,0-.645.04l-.238.077c.037-.149.071-.285.1-.421a.063.063,0,0,1,.046-.046,6.1,6.1,0,0,1,1.074-.35,1.7,1.7,0,0,1,1.076.111,1,1,0,0,1,.534.958,7.289,7.289,0,0,1-.342,1.554c-.088.338-.2.669-.262,1.014a1.385,1.385,0,0,0-.026.513.352.352,0,0,0,.333.319,1.509,1.509,0,0,0,.763-.094l.083-.03-.1.426c-.006.023-.024.031-.044.039-.278.106-.553.219-.837.309a4.123,4.123,0,0,1-.407.078Z",
    transform: "translate(-3536 1375.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3554.232-1402.867a.392.392,0,0,0,.125.03.916.916,0,0,1,.658,1.225.92.92,0,0,1-.756.574.982.982,0,0,1-.983-.4.888.888,0,0,1,.3-1.291,1.391,1.391,0,0,1,.4-.14Z",
    transform: "translate(-3551.594 1402.867)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7-.5A7.5,7.5,0,1,1-.5,7,7.508,7.508,0,0,1,7-.5Zm0,14A6.5,6.5,0,1,0,.5,7,6.507,6.507,0,0,0,7,13.5Z",
    transform: "translate(3476.027 -1433.672)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.a5b770217bcb33daf05f7df8240a3085.svg";
export { ForwardRef as ReactComponent };